<!--
@Author: Calvin Green <calvin>
@Date:   2022-02-24T16:23:20+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-12T20:30:38+02:00
@Copyright: Diversitude 2022
-->



<template>
    <b-card>
        <b-row>
            <b-col cols="12">
                <b-button variant="outline-primary" class="ms-auto mb-1" style="float: right;" @click="showUserModal('new')">Add User</b-button>
            </b-col>

            <b-col cols="12">
                <webix-ui :config="ui" v-model="users"></webix-ui>
            </b-col>
        </b-row>
        <UserModal
        v-if="show_modal"
        :user_data="selected_user_object"
        />
    </b-card>
</template>

<script>
import UserModal from './userModal.vue'
import _ from 'lodash'
import { ccbAdminState, ccbAdminMethods } from '@/state/helpers'
export default {
    components:{
        UserModal,
    },
    data:() => ({
        selected_user_object: null,
        show_modal: false,
        ui:{
            id: 'clientUsersTable',
            view:'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            columns:[
                { id:"id", header:"", hidden: true, fillspace: 0},
                { id:"name", header:"Name", fillspace: true},
                { id:"email", header:"Email", fillspace:1},
                { id:"designation", header:"Designation", fillspace:1},
            ],
            on: {
                onItemClick(id){
                    let el = this.$scope.$parent;
                    var item = this.getItem(id)
                    el.selected_user_object = {
                        id: item.id,
                        name: item.name,
                        cell_no: item.cell_no,
                        email: item.email,
                        designation: item.designation,
                        id_number: item.id_number,
                        academic_qualifications: item.academic_qualifications,
                        work_qualifications: item.work_qualifications,
                        years_experience: item.years_experience,
                        id_copy_s3_src: item.id_copy_s3_src,
                        job_desc_s3_src: item.job_desc_s3_src,
                        letter_of_acceptance_s3_src: item.letter_of_acceptance_s3_src,
                        letter_of_appointment_s3_src: item.letter_of_appointment_s3_src,
                        police_clearance_s3_src: item.police_clearance_s3_src,
                    };
                    el.showUserModal('existing', el.selected_user_object);
                }
            },
            onClick:{},
        },
    }),
    props:{
        selected_level_id:{
            default: null,
        }
    },
    computed:{
        ...ccbAdminState,
        users(){
            if(this.admin_users != null){
                let data = _.cloneDeep(this.admin_users);
                return data;
            }
            else{
                return [];
            }
        }
    },
    methods:{
        ...ccbAdminMethods,
        showUserModal(type, user = null){//new - existing
            if(type === 'new'){
                this.selected_user_object = user;
                this.show_modal = true;
                this.$nextTick(()=>{
                    this.$bvModal.show('ccbAdminUsersModal');
                    this.$root.$once('bv::modal::hidden',(event)=>{
                        if(event.type == 'hidden' && event.componentId == 'ccbAdminUsersModal'){
                            this.show_modal = false;
                        }
                    })

                })
            }
            else{
                this.show_modal = true;
                this.$nextTick(()=>{
                    this.$bvModal.show('ccbAdminUsersModal');
                    this.$root.$once('bv::modal::hidden',(event)=>{
                        if(event.type == 'hidden' && event.componentId == 'ccbAdminUsersModal'){
                            this.show_modal = false;
                        }
                    })
                })
            }
        },
    },
    mounted(){
        this.loadAdminUsers()
        .then(()=>{

        });
    },
}
</script>

<style>

</style>
